<template>
  <div class="icon-big" :class="[centesr ? 'centesr' : '']">
    <img v-for="item in iconListbig" @click="openLink(item.link)" :src="item.url" alt="">
  </div>
</template>
<script>

export default {
  props:{
    centesr: {
      type: String,
    }
  },
  name: "index",
  data() {
    return {
      iconListbig: [
        {url: require('../../assets/icon/icon.png'), link: ''},
        {url: require('../../assets/icon/icon1.png'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon/icon2.png'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon/icon3.png'), link: 'https://www.google.com/'},
        {url: require('../../assets/icon/icon4.png'), link: 'https://www.reddit.com/'},
        {url: require('../../assets/icon/icon5.png'), link: 'https://www.pinterest.com/'},
        {url: require('../../assets/icon/icon6.png'), link: 'mailto:#'},
      ],
    }
  },
  methods: {
    openLink(link) {
      window.open(link)
    },
  },
}

</script>
<style scoped lang="scss">
.icon-big {
  display: flex;
  margin-bottom: 50px;

  img {
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.centesr {
  align-items: center;
  justify-content: center;
}

</style>